import React from 'react';

const META_OAUTH_URL =
  'https://www.facebook.com/v21.0/dialog/oauth' +
  '?client_id=1274087614384236' +
  '&redirect_uri=https://crespocyberconsulting.com/auth/meta-callback' +
  '&scope=pages_messaging,pages_read_user_content,pages_read_engagement,pages_manage_posts,pages_show_list,pages_utility_messaging,' +
  'instagram_basic,instagram_manage_comments,instagram_manage_messages,' +
  'instagram_content_publish,instagram_business_content_publish,' +
  'whatsapp_business_messaging,whatsapp_business_management,' +
  'ads_read,business_management' +
  '&response_type=code';

const CheckIcon = () => (
  <svg
    className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2.5}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const Onboard = () => {
  return (
    <div className="min-h-screen ccc-operator-hero px-4 py-20 text-white">
      <div className="mx-auto grid w-full max-w-5xl gap-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(22rem,0.7fr)] lg:items-center">
        <section>
          <p className="ccc-kicker mb-5">Meta authorization</p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-black leading-tight max-w-2xl">
            Authorize only the Meta access needed for client operations.
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-200">
            This connects the business assets required for messaging, page
            operations, Instagram handling, and reporting. Permission changes
            remain visible inside Meta Business Settings.
          </p>
          <dl className="mt-8 grid gap-5 sm:grid-cols-3">
            <div className="ccc-metric">
              <dt>Flow</dt>
              <dd>Meta OAuth</dd>
            </div>
            <div className="ccc-metric">
              <dt>Access</dt>
              <dd>Scoped</dd>
            </div>
            <div className="ccc-metric">
              <dt>Owner control</dt>
              <dd>Revocable</dd>
            </div>
          </dl>
        </section>

        <section className="ccc-dossier p-6 md:p-7">
          <div className="mb-6 flex items-start justify-between gap-4">
            <div>
              <p className="ccc-dossier-label mb-2">Permission package</p>
              <h2 className="text-2xl font-bold text-white">What gets connected</h2>
            </div>
            <div className="ccc-dossier-badge">META</div>
          </div>

          <ul className="mb-8 space-y-5">
            <li className="flex items-start gap-3">
              <CheckIcon />
              <div>
                <span className="font-semibold text-white">WhatsApp Business messaging</span>
                <p className="mt-1 text-sm text-slate-300">
                  Send and receive customer messages through the approved
                  business channel.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <CheckIcon />
              <div>
                <span className="font-semibold text-white">Facebook and Instagram operations</span>
                <p className="mt-1 text-sm text-slate-300">
                  Support page content, comments, messages, and account
                  visibility.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <CheckIcon />
              <div>
                <span className="font-semibold text-white">Ads and business reporting</span>
                <p className="mt-1 text-sm text-slate-300">
                  Read campaign and business data needed for performance
                  review.
                </p>
              </div>
            </li>
          </ul>

          <a
            href={META_OAUTH_URL}
            className="ccc-primary-btn w-full py-3.5 text-base"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.791-4.697 4.533-4.697 1.313 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.884v2.27h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
            </svg>
            Continue with Meta
          </a>

          <p className="mt-5 text-center text-xs leading-relaxed text-slate-400">
            You authorize Crespo Cyber Consulting LLC to access the selected
            permissions on your behalf. You can revoke access at any time from
            Meta Business Settings.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Onboard;
